import { useQuery } from 'react-query';

import { DocChronologySummary } from '../../../../backend/src/matter/subset/chronology/doc-chronology/dto/get-doc-chronologies-response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useGetMatterDocChronologies = ({ matterId }: { matterId: string | null }) => {
  const fetcher = useFetcher();

  return useQuery<DocChronologySummary[]>(
    [QueryEntity.MatterDocChronologies, { matterId }],
    () => fetcher(`${APIBaseChronos}/api/matters/${matterId}/doc-chronologies`),
    { refetchOnWindowFocus: false, enabled: !!matterId },
  );
};
